// 移动端长按没超过这个数视为点击，参考的此处 https://github.com/ftlabs/fastclick/blob/main/lib/fastclick.js
const tapTouchTime = 200;

export const onLongTouch = (
  target: EventTarget,
  handler: Function,
  time: number
) => {
  if (!target) {
    throw new Error("onLongTouch error: 请传入正确的 target");
  }

  if (time <= tapTouchTime) {
    throw new Error("onLongTouch error: 时间间隔过短");
  }

  let startTime = Date.now();

  const timer = setInterval(() => {
    if (Date.now() - startTime >= time) {
      cancel();
      handler();
    }
  }, 100);

  const cancel = () => clearInterval(timer);

  target.addEventListener("touchend", function touchEndListener() {
    cancel();
    target.removeEventListener("touchend", touchEndListener);
  });
  target.addEventListener("touchmove", function touchMoveListener() {
    cancel();
    target.removeEventListener("touchend", touchMoveListener);
  });
  target.addEventListener("touchcancel", function touchCancelListener() {
    cancel();
    target.removeEventListener("touchend", touchCancelListener);
  });

  return cancel;
};

export const onTap = (target: EventTarget, handler: Function) => {
  if (!target) {
    throw new Error("onTap error: 请传入正确的 target");
  }

  let startTime = Date.now();
  let moved = false;

  target.addEventListener("touchend", function touchEndListener() {
    if (Date.now() - startTime <= tapTouchTime && !moved) {
      handler();
    }

    target.removeEventListener("touchend", touchEndListener);
  });

  target.addEventListener("touchmove", function touchMoveListener() {
    moved = true;
    target.removeEventListener("touchend", touchMoveListener);
  });
};
